module.exports = __webpack_public_path__ + "static/mindstorms-66887cb1712f3789a3916f030acefb35.jpg";